import {BaseResponse} from './internal/baseresponse';
import {PushList} from './internal/list/pushlist';


export class PushListResult extends BaseResponse {
  data: PushList;
}



// WEBPACK FOOTER //
// ./src/app/response/pushlistresult.ts